/** 
 * @type {MediaFilesFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    user_ids: null,
    titles: null,
}
/** 
* @returns {MediaFilesFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/MediaFilesFilter.js